export default function (self, activeElement) {
  const parent = activeElement.closest('.keynav')
  if (parent && parent.className) {
    if (parent.className.includes('el-select')) {
      let id
      if (parent.getElementsByTagName('div')[0].id) {
        id = parent.getElementsByTagName('div')[0].id
      } else {
        id = parent.getElementsByTagName('input')[0].id
      }
      return self.$refs[id][0]
    }
    try {
      if (self.$refs[parent.id]) {
        return self.$refs[parent.id][0]
      } else {
        return self.$refs[`autocomplete__${parent.id}`][0]
      }
    } catch (e) {
      throw new TypeError(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/GetActiveElementRef.js